import { IInfluxAPI } from './InfluxAPIInterface';
import type { TimeSeriesResponse } from '../../components/TileDisplay';

export class InfluxAPIMock implements IInfluxAPI {
    async postInfluxSQL(): Promise<TimeSeriesResponse> {
        return {
            source: 'influx',
            rows: [
                {
                    timestamp: new Date(1749659942000).toISOString(),
                    values: {
                        field_0: 0.736,
                        field_1: 0.415,
                    },
                    tags: {
                        tag_0: '0',
                        tag_1: '1',
                    },
                },
                {
                    timestamp: new Date(1749660002000).toISOString(),
                    values: {
                        field_0: 0.067,
                        field_1: 0.582,
                    },
                    tags: {
                        tag_0: '0',
                        tag_1: '1',
                    },
                },
                {
                    timestamp: new Date(1749660062000).toISOString(),
                    values: {
                        field_0: 0.998,
                        field_1: 0.5,
                    },
                    tags: {
                        tag_0: '0',
                        tag_1: '1',
                    },
                },
            ],
        };
    }
}